import { render, staticRenderFns } from "./PersonnelCategorical.vue?vue&type=template&id=06904b7d&scoped=true&"
import script from "./PersonnelCategorical.vue?vue&type=script&lang=js&"
export * from "./PersonnelCategorical.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelCategorical.vue?vue&type=style&index=0&id=06904b7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06904b7d",
  null
  
)

export default component.exports